<template>
    <div class="gas_elec_wrap">
        <me-collapes @collapesCb="collapesCb" :treeTitle="title">
            <me-tree
                ref="myTree"
                :treeData="treeData"
                :title="title"
                :treeLoading="treeLoading"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :defaultCheckKeys="defaultCheckKeys"
                :treeToolBar="treeToolBar"
                @handleTreeNodeClick="handleTreeNodeClick"
                :defaultExpandedKeys="defaultExpandedKeys"
                :isSingle="true"
            ></me-tree>
        </me-collapes>
        <div class="gas_data_wrap">
            <template
                v-if="selectObj.is_imaginary == 1 || selectObj.gs_Q == 1 || selectObj.is_kind == 1"
            >
                <el-tabs
                    v-model="tabVal"
                    type="card"
                    @tab-click="handleTabClick"
                    class="leader-tab"
                >
                    <el-tab-pane
                        label="标准总量"
                        name="one"
                        v-if="selectObj.is_imaginary == 1 || selectObj.gs_Q == 1"
                    >
                        <gas-monitor :id="selectObj.point_id"></gas-monitor>
                    </el-tab-pane>
                    <el-tab-pane label="瞬时量分析" name="two" v-if="selectObj.is_kind == 1">
                        <gas-instant :id="selectObj.point_id"></gas-instant>
                    </el-tab-pane>
                </el-tabs>
            </template>

            <template v-else>
                <div style="text-align: center;line-height: 100%;height: 100%">
                    <img
                        style="margin-top: 10rem;"
                        src="../../../assets/image/custom/no-collector.jpg"
                    />
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import monitor from "./components/gas_monitor.vue";
import instant from "./components/gas_instant.vue";
import * as api from "../../../http/Use_electricity_monitor";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes,
        "gas-monitor": monitor,
        "gas-instant": instant,
    },
    data() {
        return {
            treeData: [],
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            defaultCheckKeys: [],
            defaultExpandedKeys: [],
            title: "采集点选择",
            treeLoading: false,
            treeToolBar: false,
            contWidth: false,
            tabVal: "one", //默认电量
            // selectPid: "", //选中的树id
            selectObj: {},
        }
    },
    created() {
        this.getUnitPointList();
    },
    methods: {
        //获取采集点
        getUnitPointList() {
            api.getUnitPointList({ point_class_id: '006' }).then(res => {
                if (res && res.error_code === "0") {
                    this.treeData = res.bus_json;
                    this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    this.defaultExpandedKeys = [res.bus_json.length > 0 && res.bus_json[0].point_id]
                }
            });
        },
        handleTreeNodeClick(sth) {
            this.selectObj = sth;
            if (sth.is_kind == 1) {
                this.tabVal = "two";
            }
            if (sth.is_imaginary == 1 || sth.gs_Q == 1) {
                this.tabVal = "one";
            }
            // this.defaultCheckKeys = [sth];
        },
        handleTabClick(tab) {
            if (tab.name == 'one') {
                // 电量分析
            } else if (tab.name == 'two') {
                // 瞬时量分析
            }
        }
    }
}
</script>
<style lang="scss">
.gas_elec_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    padding: 0 40px;
    box-sizing: border-box;
    .gas_data_wrap {
        width: calc(100% - 280px);
        height: 100%;
        padding-left: 20px;
        box-sizing: border-box;
    }
}
</style>